import { OverlayTrigger, Popover, PopoverContent } from 'react-bootstrap';
import { Input } from '../Input/Input';

const CustomerValidation = ({
  isValid,
  companyName,
  companyId,
  onKebabClick,
  onCancel,
  onCreateLoad,
  cabieStatusValid,
  cabieStatus,
  billableCustomerValid,
  billableCustomer,
  cm8ApprovedValid,
  cm8Approved,
  dbStatusValid,
  dbStatus,
  isCustomaite = false,
  heading = 'Load Validation',
}) => {
  const Warning = () => (
    <OverlayTrigger
      placement="top"
      trigger={['hover', 'focus']}
      overlay={
        <Popover style={{ minWidth: 'auto' }}>
          <PopoverContent>
            <p>Please fix the highlighted customer settings.</p>
          </PopoverContent>
        </Popover>
      }
    >
      <p className="bp-warning-paragraph mx-2">
        <span className="warning bp-warning"></span>
      </p>
    </OverlayTrigger>
  );

  return (
    <section className="floating-box-newload mt-4" style={{ width: '35%', margin: '0 auto' }}>
      <h1 className="floating-box-header-newload cm8">
        <span>{heading}</span>
        {!isValid && <Warning />}
      </h1>
      <div className="section-group">
        <div className="section">
          <h1 className="title">Customer Validation</h1>
          <div className="content">
            <div className="form-field">
              <Input
                label="Invoice Customer"
                name="invoiceCustomer"
                type="text"
                value={companyName && companyId ? `${companyName} (${companyId})` : `-`}
                required
                disabled={true}
                optionsButton={true}
                optionsButtonCallback={onKebabClick}
              />
            </div>
            <div className="form-field">
              <Input
                label="CABIE Status"
                name="cabieStatus"
                className={!cabieStatusValid && 'error'}
                type="text"
                value={cabieStatus}
                required
                disabled={true}
              />
            </div>
            <div className="form-field">
              <Input
                label="Billable Customer"
                name="billableCustomer"
                type="text"
                className={!billableCustomerValid && 'error'}
                value={billableCustomer}
                required
                disabled={true}
              />
            </div>
            {isCustomaite && (
              <div className="form-field">
                <Input
                  label="CM8 Approved"
                  name="customaiteApproved"
                  className={!cm8ApprovedValid && 'error'}
                  type="text"
                  value={cm8Approved}
                  required
                  disabled={true}
                />
              </div>
            )}
            <div className="form-field">
              <Input
                label="DB Status"
                name="dbStatus"
                type="text"
                className={!dbStatusValid && 'error'}
                value={dbStatus}
                required
                disabled={true}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex pb-3 px-3 w-100 justify-content-between">
        <button
          className="epo-continue-button small-button"
          type="button"
          onClick={() => {
            onCancel();
          }}
        >
          Cancel
        </button>
        <button
          className="blue-button-newload small-button"
          disabled={!isValid || !cm8ApprovedValid}
          type="button"
          onClick={onCreateLoad}
        >
          Create Load
        </button>
      </div>
    </section>
  );
};

export default CustomerValidation;
